export default {
  en: {
    name: "English",
    iso: "en_US",
    load: () => {
      return import("./en_US.json");
    },
  },
  fr: {
    name: "Français",
    iso: "fr_FR",
    load: () => {
      return import("./fr_FR.json");
    },
  },
};